import { CustomToggleButtonGroupItem } from '@aibees/shared/components';
import {
  AddJobRoleExpanderResponse,
  JobTitleCategoryToggleButtonType,
} from '../../types';

export const getConfig = (
  data?: AddJobRoleExpanderResponse
): CustomToggleButtonGroupItem[] => [
  {
    name: 'All Titles',
    value: JobTitleCategoryToggleButtonType.AllTitles,
    key: JobTitleCategoryToggleButtonType.AllTitles,
  },
  {
    name: 'By Categories',
    value: JobTitleCategoryToggleButtonType.ByCategories,
    key: JobTitleCategoryToggleButtonType.ByCategories,
    disabled: data?.titles && 'combined' in data.titles,
  },
];
